exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=radio][data-v-2bb54d62]{display:none}.radio-check[data-v-2bb54d62]{cursor:pointer}", ""]);

// exports
